module.exports = __webpack_public_path__ + "static/media/BHC.54644897.svg";